import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconNewsletter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 51,
	height: 37,
	viewBox: "0 0 51 37",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 34V9C10 7.89543 10.8954 7 12 7H48C49.1046 7 50 7.89543 50 9V34C50 35.1046 49.1046 36 48 36H12C10.8954 36 10 35.1046 10 34Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 30H45",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33 22V14C33 12.8954 33.8954 12 35 12H43C44.1046 12 45 12.8954 45 14V22C45 23.1046 44.1046 24 43 24H35C33.8954 24 33 23.1046 33 22Z",
			fill: "currentColor",
			stroke: "white",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.57143 11L3.04839 13.3118C1.94565 13.7026 1.41236 14.9524 1.89322 16.0189L10 34",
			stroke: "currentColor",
			fill: "none",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 7L41.0168 1.58556C42.0434 1.25891 43.1443 1.80415 43.5067 2.81874L45 7",
			stroke: "currentColor",
			fill: "none",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 24H28",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 18.5H28",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 13H28",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgIconNewsletter;
